import { motion, AnimatePresence } from "framer-motion";
import { Phone } from "lucide-react";
import { contact } from "../data/siteConfig";

// Single shared call selector — every Call action on the site opens this,
// so the customer chooses Landline or Mobile themselves.
export const CallSheet = ({ open, onClose }) => (
    <AnimatePresence>
        {open && (
            <motion.div
                className="fixed inset-0 z-[80] flex items-end justify-center bg-black/50 p-4 backdrop-blur-sm sm:items-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={onClose}
                role="dialog"
                aria-modal="true"
                aria-label="Call Mākara Cattery"
                data-testid="call-sheet"
            >
                <motion.div
                    className="w-full max-w-sm rounded-3xl border border-stone-200 bg-cream p-6 pb-[max(env(safe-area-inset-bottom),1.5rem)] shadow-2xl"
                    initial={{ y: 60, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 60, opacity: 0 }}
                    transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <p className="text-center font-mono text-[10px] uppercase tracking-[0.3em] text-stone-500">
                        Call Mākara Cattery
                    </p>
                    <div className="mt-5 space-y-3">
                        <a
                            href={`tel:${contact.landline.href}`}
                            onClick={onClose}
                            data-testid="call-sheet-landline"
                            className="flex items-center justify-between gap-3 rounded-2xl border border-stone-200 bg-white px-5 py-4 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-fern"
                        >
                            <span className="flex items-center gap-3">
                                <Phone className="h-5 w-5 text-fern" aria-hidden="true" />
                                <span className="font-serif text-xl font-semibold text-[#1c1917]">
                                    Landline
                                </span>
                            </span>
                            <span className="font-mono text-sm text-stone-600">
                                +64 4 476 9424
                            </span>
                        </a>
                        <a
                            href={`tel:${contact.mobile.href}`}
                            onClick={onClose}
                            data-testid="call-sheet-mobile"
                            className="flex items-center justify-between gap-3 rounded-2xl border border-stone-200 bg-white px-5 py-4 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-fern"
                        >
                            <span className="flex items-center gap-3">
                                <Phone className="h-5 w-5 text-fern" aria-hidden="true" />
                                <span className="font-serif text-xl font-semibold text-[#1c1917]">
                                    Mobile
                                </span>
                            </span>
                            <span className="font-mono text-sm text-stone-600">
                                +64 27 476 9424
                            </span>
                        </a>
                    </div>
                    <button
                        onClick={onClose}
                        data-testid="call-sheet-cancel"
                        className="mt-4 w-full rounded-full border border-stone-300 py-3.5 text-base font-semibold text-stone-600 transition-colors duration-200 hover:border-stone-500 hover:text-[#1c1917]"
                    >
                        Cancel
                    </button>
                </motion.div>
            </motion.div>
        )}
    </AnimatePresence>
);
